import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import EmailSignatureModel from '../models/EmailSignatureModel';

interface EmailSignatureState {
    signatures: EmailSignatureModel[],
    triggerSearch: number,
    selectedItem: EmailSignatureModel,
    defaultSignature: EmailSignatureModel,
    defaultEvoSignature: EmailSignatureModel,
    isShowEmailSignatureEditor: boolean

}

const initialState: EmailSignatureState = {
    signatures: [],
    triggerSearch: 0,
    selectedItem: {
        id: "",
        name: "",
        signature: "",
    } as EmailSignatureModel,
    defaultSignature: {
        id: "",
        name: "",
        signature: "",
    } as EmailSignatureModel,
    defaultEvoSignature: {
        id: "",
        name: "",
        signature: "",
    } as EmailSignatureModel,
    isShowEmailSignatureEditor: false
}

export const EmailSignatureSlice = createSlice({
    name: "EmailSignature",
    initialState,
    reducers: {
        setEmailSignatures: (state, action: PayloadAction<EmailSignatureModel[]>) => {
            state.signatures = action.payload;
        },
        setTriggerSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setSelectedSignature: (state, action: PayloadAction<EmailSignatureModel>) => {
            state.selectedItem = action.payload;
        },
        setDefaultSignature: (state, action: PayloadAction<EmailSignatureModel>) => {
            state.defaultSignature = action.payload;
        },
        setDefaultEvoSignature: (state, action: PayloadAction<EmailSignatureModel>) => {
            state.defaultEvoSignature = action.payload;
        },
        setIsShowEmailSignatureEditor: (state, action: PayloadAction<boolean>) => {
            state.isShowEmailSignatureEditor = action.payload;
        },
        setName: (state, action: PayloadAction<string>) => {
            state.selectedItem.name = action.payload;
        },
        setSignature: (state, action: PayloadAction<string>) => {
            state.selectedItem.signature = action.payload;
        },
        setSelectedItem: (state, action: PayloadAction<EmailSignatureModel>) => {
            state.selectedItem = action.payload;
        },
        resetSelectedSignature: (state) => {
            state.selectedItem = { ...initialState.selectedItem };
        },
    }
});

export const EmailSignatureSelector = createSelector(
    (state: RootState) => state.emailSignature,
    (data) => data
);

export const {
    setEmailSignatures,
    setTriggerSearch,
    setSelectedSignature,
    setDefaultSignature,
    setDefaultEvoSignature,
    setIsShowEmailSignatureEditor,
    setName,
    setSignature,
    setSelectedItem,
    resetSelectedSignature
} = EmailSignatureSlice.actions;

export default EmailSignatureSlice.reducer;